import React, { useState } from "react";
import { DashboardLayout } from "../../components/layout";

import LocationSelector from "../../components/dashboard/LocationSelector";
// import OfferFilters from "../../components/dashboard/OfferFilters";
// import OffersTable from "../../components/dashboard/OffersTable";
import GstWarning from "../../components/dashboard/GstWarning";
import BannerCards from "../../components/dashboard/BannerCards";
import NewsSlider from "../../components/dashboard/NewsSlider";
import BottomBanner from "../../components/dashboard/BottomBanner";
import InquirySection from "../../components/dashboard/InquirySection";
import FloatingCallButton from "../../components/dashboard/FloatingCallButton";

const Dashboard = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const breadcrumbs = [
    { label: "Seller", link: "/dashboard" },
    { label: "Dashboard" }
  ];

  return (
    <DashboardLayout
      breadcrumbs={breadcrumbs}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
    >

      <LocationSelector />

      {/* <OfferFilters /> */}

      {/* <OffersTable /> */}

      <GstWarning />

      <BannerCards />

      <NewsSlider />

      <BottomBanner />

      <InquirySection />

      <FloatingCallButton />

    </DashboardLayout>
  );
};

export default Dashboard;